import Monaco, { useMonaco } from "@monaco-editor/react";
import { useEffect } from "react";
import { IMonacoEditor } from "./interface";

const MonaccoEditor = (props: IMonacoEditor) => {
    const { data, monacoEditorFlag, setCompletionDisposable, defaultValue, completionDisposable, setCurrentManoccoValue, currentManoccoValue } = props;
    useEffect(()=>{
        if(defaultValue){
            setCurrentManoccoValue && setCurrentManoccoValue(defaultValue)
        }
    },[])
    const monaco = useMonaco();

    const editorOptions: any = {
        ariaLabel: 'iot editor',
        selectOnLineNumbers: false,
        lineNumbers: 'on',
        lineNumbersMinChars: 3,
        accessibilitySupport: 'off',
        cursorBlinking: 'smooth',
        // automaticLayout: true,
        smoothScrolling: true,
        suggestSelection: 'first',
        // revealHorizontalRightPadding: 20,
        // overviewRulerBorder: false,
        lineHeight: 25,
        theme: 'myCoolTheme',
        language: 'newlang', // 'javascript',
        autoIndent: false,
        folding: false,
        iconsInSuggestions: false,
        wordWrap: 'on', // 'wordWrapColumn',
        // wrappingIndent: 'same',
        minimap: {
            enabled: false,
        },
        wordBasedSuggestions: false,
        suggestFontSize: 10,
        autoClosingQuotes: 'always',
        acceptSuggestionOnCommitCharacter: false,
        scrollbar: {
            verticalScrollbarSize: 10,
        },
        contextmenu: false,
        // formatOnType: true,
        dragAndDrop: false,
        // roundedSelection: false,
        scrollBeyondLastLine: false,
        unfoldOnClickAfterEndOfLine: true,
        // readOnly: false,
    };

    const enhanceSuggestions = (sList: any, range: any) => {
        sList.forEach((item: any) => {
            item["range"] = range;
        });
        return sList;
    }

    const editorWillMount = () => {
        const ind: any = monaco?.languages?.getLanguages().findIndex((dataEle: any) => dataEle?.id === "newlang")
        if (ind === -1) {
            monaco?.languages.register({ id: 'newlang' });
            monaco?.languages.setMonarchTokensProvider('newlang', {
                tokenizer: {
                    root: [],
                },
                ignoreCase: false,
                tokenPostfix: '.newlang',
            });
        }
        setCompletionDisposable && setCompletionDisposable(
            monaco?.languages.registerCompletionItemProvider("newlang", {
                provideCompletionItems: function (model, position) {
                    var word = model.getWordUntilPosition(position);
                    var range = {
                        startLineNumber: position.lineNumber,
                        endLineNumber: position.lineNumber,
                        startColumn: word.startColumn,
                        endColumn: word.endColumn,
                    };
                    return {
                        suggestions: enhanceSuggestions(data, range)
                    };
                },
            })
        );
    };
    const handleEditorChange = (value: any, event: any) => {
        setCurrentManoccoValue && setCurrentManoccoValue(value);
    }
    return (
        <>
            <Monaco
                height="55vh"
                defaultLanguage="newlang"
                // keepCurrentModel={true}
                defaultValue={defaultValue && defaultValue}
                beforeMount={editorWillMount}
                options={editorOptions}
                onChange={handleEditorChange}
            />
        </>
    )

}
export default MonaccoEditor;